/* template */
<template><span class="text-money"><template v-if="(priceType === 'HKD')"><span class="price__new icon-hkd" v-if="(price || priceNew)">{{price || priceNew}}</span></template><template v-else><span class="price__new icon-rmb" v-if="(price || priceNew)">{{price || priceNew}}</span></template></span></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m35e493b0"}'>
.text-money
  font-family: PingFangSC-Semibold
  line-height: 30rpx;
  .price__new
    display inline-block
    font-size: 36rpx;
    font-weight: 700;
    color: #FC9153;
    margin-right: 10rpx;
    vertical-align: middle;
  .price__old
    display: inline-block;
    color: #999;
    font-size: 24rpx;
    vertical-align: middle;
    opacity: 0.6;
    background-image: url(https://dpubstatic.udache.com/static/dpubimg/Ax_NkYewJW/line2.png);
    background-position: center center;
    background-repeat: repeat-x;
    padding: 0 10rpx;
  .icon-rmb::before
    content: "¥"
  .icon-hkd::before
    content: "HK$"
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    price: {
      type: null,
      value: '',
    },
    priceNew: {
      type: null,
      value: '',
    },
    priceOld: {
      type: null,
      value: '',
    },
    priceType: {
      type: null,
      value: 'CNY',
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "text-money35e493b0",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
